module.exports = __webpack_public_path__ + "static/media/ic_elect_azul.7d470188.svg";